import { useCurrentEnterpriseId } from '@mews-commander/core';
import { EnterpriseLink } from '@mews-commander/ui';
import { AuditName } from './AuditName';
import { auditToLinkProps } from './utils';

type AuditNameLinkParams = Pick<React.ComponentProps<typeof AuditName>, 'fieldIdentifier'>;

export const AuditNameLink = ({ fieldIdentifier }: AuditNameLinkParams) => {
    const enterpriseId = useCurrentEnterpriseId();
    const linkProps = auditToLinkProps(fieldIdentifier, { enterpriseId });

    if (!linkProps) {
        return <AuditName fieldIdentifier={fieldIdentifier} />;
    }

    return (
        <EnterpriseLink {...linkProps} variant="basic" target="_blank" rel="noreferrer">
            <AuditName fieldIdentifier={fieldIdentifier} />
        </EnterpriseLink>
    );
};
